import React from "react";
import "./responsivemenu.css";
import { motion } from "motion/react";
import { iconBox, iconslide, listslide, menuslide } from "./framerAnimation";
import { menudata, responsiveMenu, subMenuData } from "../../menu/menudata";
import { useNavigate } from "react-router-dom";
import {
  FaFacebookF,
  FaLinkedinIn,
  FaYoutube,
  FaInstagram,
  FaTelegramPlane,
} from "react-icons/fa";
import { FaThreads, FaXTwitter, FaWhatsapp } from "react-icons/fa6";

import Curve from "./Curve";
import { useQuery } from "react-query";
import axios from "axios";
import { BASEURL } from "../../../utils/BaseUrl";
import { handleTopScroll } from "../../../common/function/ScroolTop";

const ResponsivesideBar = ({ setMenuStatus }) => {
  const navigate = useNavigate();

  const handleNavigate = (path) => {
    navigate(path);
    handleTopScroll();

    setMenuStatus(false);
  };
  const { data } = useQuery({
    queryKey: "getallSoacilmedia",
    queryFn: () =>
      axios.get(`${BASEURL}social-media`).then((res) => {
        return res?.data;
      }),
  });
  return (
    <motion.div
      variants={menuslide}
      initial="initial"
      animate="enter"
      exit="exit"
      className="sidebar-mainbox"
    >
      <div className="realtive">
        {responsiveMenu.map((v, i) => {
          return (
            <motion.div
              custom={i}
              key={v.id}
              variants={listslide}
              initial="initial"
              animate="enter"
              exit="exit"
              className="list-items"
            >
              {v.id ? (
                <p onClick={() => handleNavigate(v.path)}>{v.title}</p>
              ) : (
                <p onClick={() => handleNavigate(v.path)}>{v.title}</p>
              )}
            </motion.div>
          );
        })}

        <motion.div
          initial="initial"
          animate="enter"
          exit="exit"
          className="last-box"
        >
          <div className="last-inside">
            {data?.links?.map((v, i) => {
              return (
                <motion.div
                  key={i}
                  custom={i}
                  variants={iconslide}
                  initial="initial"
                  animate="enter"
                  exit="exit"
                >
                  {v.status && (
                    <p>
                      <a href={v.url} target="_blank">
                        <span className="text-speed-red">
                          {v?.platform?.toLowerCase() == "facebook" ? (
                            <FaFacebookF className="font-semibold text-lg w-5 h-5" />
                          ) : v?.platform?.toLowerCase() == "linkedin" ? (
                            <FaLinkedinIn className="font-semibold text-lg w-5 h-5" />
                          ) : v?.platform?.toLowerCase() == "youtube" ? (
                            <FaYoutube className="font-semibold text-lg w-5 h-5" />
                          ) : v?.platform?.toLowerCase() == "twitter" ? (
                            <FaXTwitter className="font-semibold text-lg w-5 h-5" />
                          ) : v?.platform?.toLowerCase() == "instagram" ? (
                            <FaInstagram className="font-semibold text-lg w-5 h-5" />
                          ) : v?.platform?.toLowerCase() == "telegram" ? (
                            <FaTelegramPlane className="font-semibold text-lg w-5 h-5" />
                          ) : v?.platform?.toLowerCase() == "threads" ? (
                            <FaThreads className="font-semibold text-lg w-5 h-5" />
                          ) : v?.platform?.toLowerCase() == "whatsapp" ? (
                            <FaWhatsapp className="font-semibold text-lg w-5 h-5" />
                          ) : (
                            ""
                          )}
                        </span>
                      </a>
                    </p>
                  )}
                </motion.div>
              );
            })}
          </div>
        </motion.div>
      </div>
    </motion.div>
  );
};

export default ResponsivesideBar;
